<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">Budding Hopes</span></p>
<p class="p0">By Vivien Dean</p>
<p class="p2"><a id="a4"></a><a href="#/005#a9">Chapter 1</a></p>
<p class="p2"><span href="#/006#a10" title="Link target outside of Sample">Chapter 2</span></p>
<p class="p2"><span href="#/007#a11" title="Link target outside of Sample">Chapter 3</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?b9631cd2